import React, { Component } from 'react'
import { Link, withRouter, NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import AppBar from 'material-ui/AppBar'
import Button from 'material-ui/Button'
import IconButton from 'material-ui/IconButton'
import Menu, { MenuItem } from 'material-ui/Menu'
import Toolbar from 'material-ui/Toolbar'
import Drawer from 'material-ui/Drawer'
import MenuIcon from 'material-ui-icons/Menu'
import PersonIcon from 'material-ui-icons/Person'
import { GC_USER_ID, GC_AUTH_TOKEN } from '@/constants'
import List, { ListItem, ListItemText } from 'material-ui/List'
import ChevronLeftIcon from 'material-ui-icons/ChevronLeft'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'
import { withStyles } from 'material-ui/styles'

const drawerWidth = 200

const styles = theme => ({
  root: {
    display: 'flex'
  },
  appBar: {
    backgroundColor: 'white',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 20
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: 'grey',
    color: 'white',
    fontSize: 12
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginLeft: -drawerWidth
  },
  appHeader: {
    backgroundColor: 'white',
    color: 'lightgrey'
  }
})

@withStyles(styles, { withTheme: true })
@withRouter
export default class HeaderAlchemy extends Component {
  state = {
    anchorEl: null,
    value: '',
    openDrawer: false,
    suggestions: []
  }

  handleChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    })
  }

  handleMenu = event => {
    const anchorEl = event.currentTarget
    this.setState({ anchorEl })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  signOut = () => {
    global.localStorage.removeItem(GC_USER_ID)
    global.localStorage.removeItem(GC_AUTH_TOKEN)
    this.props.history.push(`/start`)
  }

  handleDrawerOpen = () => {
    this.setState({ openDrawer: true })
  }

  handleDrawerClose = () => {
    this.setState({ openDrawer: false })
  }

  render() {
    const { classes, theme } = this.props
    const userId = global.localStorage.getItem(GC_USER_ID)
    const { anchorEl, openDrawer } = this.state
    const open = Boolean(anchorEl)

    return (
      <div>
        <AppBar
          position="static"
          classes={{
            colorPrimary: classes.appHeader
          }}
        >
          <Toolbar style={styles.appHeader}>
            <div
              style={{
                width: '100%',
                position: 'absolute',
                left: 0
              }}
            >
              <img
                src={process.env.PUBLIC_URL + '/alchemy_title.png'}
                alt="title"
              />
            </div>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={this.handleDrawerOpen}
            >
              <MenuIcon />
            </IconButton>
            {userId ? (
              <div style={{ position: 'absolute', right: 10 }}>
                <IconButton
                  aria-owns={open ? 'menu-appbar' : 'drawer-appbar'}
                  aria-haspopup="true"
                  onClick={this.handleMenu}
                >
                  <PersonIcon align="right" style={{ color: 'lightgrey' }} />
                </IconButton>
              </div>
            ) : (
              <div style={{ position: 'absolute', right: 10 }}>
                <Button
                  size="small"
                  color="primary"
                  variant="raised"
                  component={Link}
                  to="/login"
                >
                  Login
                </Button>
              </div>
            )}
          </Toolbar>
        </AppBar>
        <Drawer
          id="drawer-appbar"
          className={classes.drawer}
          variant="persistent"
          anchor="left"
          open={openDrawer}
          classes={{
            paper: classes.drawerPaper
          }}
        >
          <div className={classes.drawerHeader}>
            <IconButton onClick={this.handleDrawerClose}>
              {theme.direction === 'ltr' ? (
                <ChevronLeftIcon style={{ color: 'white' }} />
              ) : (
                <ChevronRightIcon style={{ color: 'white' }} />
              )}
            </IconButton>
          </div>
          <List>
            <ListItem button key={'aboutAlchemy'}>
              <ListItemText
                primary={
                  <NavLink
                    to={`/start`}
                    style={{
                      color: 'white',
                      textDecoration: 'none'
                    }}
                    activeStyle={{
                      color: 'lightgrey',
                      textDecoration: 'none',
                      pointerEvents: 'none'
                    }}
                  >
                    About alchemy
                  </NavLink>
                }
              />
            </ListItem>
            {['Jobs', 'Blog', 'About us'].map((text, index) => (
              <ListItem button key={text}>
                <ListItemText
                  primary={<span style={{ color: 'white' }}>{text}</span>}
                />
              </ListItem>
            ))}
          </List>
        </Drawer>

        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={open}
          onClose={this.handleClose}
        >
          <MenuItem component={Link} to={`/`}>
            Dashboard
          </MenuItem>
          <MenuItem component={Link} to={`/preference`}>
            Preference
          </MenuItem>
          <MenuItem onClick={this.signOut}>Sign out</MenuItem>
        </Menu>
      </div>
    )
  }
}

HeaderAlchemy.propTypes = {
  classes: PropTypes.object.isRequired
}

HeaderAlchemy.defaultProps = {
  classes: {}
}



// WEBPACK FOOTER //
// ./src/components/HeaderAlchemy.js